exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-outline-dark[data-v-a19ceb66]:hover {\r\n  border-color: red;\r\n  background: red;\r\n  color: #fff;\n}\n.btn-width[data-v-a19ceb66] {\r\n  width: 93px;\n}\niframe[data-v-a19ceb66] {\r\n  width: 100%;\r\n  height: 250px;\n}\np[data-v-a19ceb66] {\r\n  margin-bottom: 5px;\n}\np a[data-v-a19ceb66] {\r\n  color: black;\n}\na[data-v-a19ceb66]:hover {\r\n  text-decoration: none;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a19ceb66","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/component/contactUs.vue
// module id = 342
// module chunks = 0